module.exports = __webpack_public_path__ + "static/media/plum.2337fa46.png";